module.exports = __webpack_public_path__ + "img/p4-2-4.93e22718.png";